"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get Autoflow () {
        return Autoflow;
    },
    get AutoflowDocument () {
        return AutoflowDocument;
    },
    get AutoflowTask () {
        return AutoflowTask;
    },
    get AutoflowTaskResponse () {
        return AutoflowTaskResponse;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _tasks = require("./tasks");
const _trigger = require("./trigger");
const AutoflowTask = _zod.z.discriminatedUnion("task_type", [
    _tasks.AutoflowTaskConsoleLog,
    _tasks.AutoflowTaskQueryUser,
    _tasks.AutoflowTaskQueryCompany,
    _tasks.AutoflowTaskReviewCycleAddUsers,
    _tasks.AutoflowTaskReviewCycleCheckCompletion,
    _tasks.AutoflowTaskReviewCycleExcludeExistingSubjects,
    _tasks.AutoflowTaskSurveyOpenEmail
]);
const AutoflowTaskResponse = _zod.z.discriminatedUnion("task_type", [
    _tasks.AutoflowTaskConsoleLogResponse,
    _tasks.AutoflowTaskQueryUserResponse,
    _tasks.AutoflowTaskQueryCompanyResponse,
    _tasks.AutoflowTaskReviewCycleAddUsersResponse,
    _tasks.AutoflowTaskReviewCycleCheckCompletionResponse,
    _tasks.AutoflowTaskReviewCycleExcludeExistingSubjectsResponse,
    _tasks.AutoflowTaskSurveyOpenEmailResponse
]);
const Autoflow = _zod.z.object({
    enabled: _zod.z.boolean().default(true),
    trigger: _trigger.AutoflowTrigger,
    tasks: AutoflowTask.array()
});
const AutoflowDocument = Autoflow.extend({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    resource_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    name: _zod.z.string().optional(),
    created_at: _zod.z.date().optional(),
    updated_at: _zod.z.date().optional(),
    deleted_at: _zod.z.date().optional()
});
